import { render, staticRenderFns } from "./teacherDisplayWidge.vue?vue&type=template&id=121c1726&scoped=true"
import script from "./teacherDisplayWidge.vue?vue&type=script&lang=js"
export * from "./teacherDisplayWidge.vue?vue&type=script&lang=js"
import style0 from "./teacherDisplayWidge.vue?vue&type=style&index=0&id=121c1726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121c1726",
  null
  
)

export default component.exports